<template>
  <div class="footer">
    <div class="bg">
      <div class="top">
        <div class="logo">
          <img src="@/assets/logo.svg" alt="logo" />
        </div>
      </div>
      <div class="adress">contact@icbench.com</div>
      <div class="bottom">© Copyright {{ year }} IC bench, Inc</div>
    </div>
  </div>
</template>
<script>

export default {
  name: "footer",
  data() {
    return {
      showHelp: false,
    };
  },
  methods: {
    helpDo() {
      this.showHelp = true;
    },
    cancelHelpDo() {
      this.showHelp = false;
    }
  },
  computed: {
    year() {
      const y = new Date()
      return y.getFullYear()
    }
  },
  created() {},
  components: {
    
  }
};
</script>
<style lang='less' scoped>
.footer {
  height: 180px;
  width: 100%;
  background-color: #F9F9F9;
  display: flex;
  justify-content: center;
  border-style: solid none none none;
  border-width: 0.25px;
  border-color: #f6f6f6;
  .bg {
    width: 100%; //1200px;//90vw;
    height: 100%;
    display: flex;
    flex-direction: column;

    .top {
      // height: 100px;
      margin-top: 45px;
      display: flex;
      align-items: center;
      margin-left: 83px;
      img {
        width: 211px;
        height: 25px;
        object-fit: contain;
      }
    }

    .adress {
      padding-left: 83px;
      background-color: #F9F9F9;
      display: flex;
      align-items: center;
      color: #0050B3;
      font-size: 16px;
      margin-top: 20px;
    }
    .bottom {
      padding-left: 83px;
      background-color: #F9F9F9;
      // height: 62px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #212121;
      margin-top: 10px;
    }
  }
}

</style>